import React from "react";
import SmartBg from "../../assets/img/services/contract/smart.svg";
import SmartBg1 from "../../assets/img/services/contract/smart1.png";
import listBg from "../../assets/img/services/contract/list.png";
import settingsSVG from "../../assets/img/services/contract/settings.svg";
import rotateSVG from "../../assets/img/services/contract/rotate.svg";

function SmartContracts() {
  return (
    <div className="">
      <div>
        <div className="flex flex-col h-full items-center">
          <div className="flex flex-col lg:flex-row w-[80%] m-auto">
            <div className="w-full lg:w-1/2 sm:hidden">
              <img
                src={SmartBg}
                alt=""
                className="m-auto w-[50%] lg:w-[60%] -mt-[5%] mb-10"
              />
            </div>
            <div className="w-full lg:w-1/2 md:hidden lg:hidden">
              <img
                src={SmartBg1}
                alt=""
                className="m-auto w-[50%] lg:w-[60%] -mt-[5%] mb-10"
              />
            </div>
            <div className="flex items-center justify-center md:w-[80%] text-left">
              <div className="block">
                <div className="text-[18px] lg:text-[24px] font-bold text-white md:text-left uppercase mb-5 sm:text-left sm:pl-8">
                  Smart contract implementation
                </div>
                <div>
                  <p className=" text-white md:text-left break-words lg:w-[90%] mb-5 text-xs md:text-lg sm:px-8">
                    Smart Contracts are now essential to any blockchain-based
                    business. The self-executing digital contract is the key to
                    a “trustless transaction”, a transaction executed
                    automatically upon fulfilment of preset conditions. This
                    ends traditional transactions where parties involved can
                    renege on agreements.
                  </p>
                  <div className="flex flex-row">
                    <div className="w-full md:w-1/2 mr-4">
                      <img src={listBg} alt="list" className="w-full" />
                    </div>
                    <div className="w-1/2 hidden md:block">
                      <div className="flex flex-col gap-5">
                        <div>
                          <img src={settingsSVG} alt="list" width={70} />
                        </div>
                        <div>
                          <img src={rotateSVG} alt="list" width={50} />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <h2 className="fixed -bottom-[21%] font-bold text-[rgba(255,255,255,0.1)] text-[12rem] leading-[140%] tracking-[0.04em] h2Mobile md:block hidden">
          TOMATE
        </h2>
      </div>
    </div>
  );
}

export default SmartContracts;
